import TableStatisticsTemplate from './TableStatisticsTemplate';

export default TableStatisticsTemplate;
